import { useRoot } from "@/composables/useRoot";

export function useNotify() {
  const $root = useRoot();

  return $root?.$notifications;
}
